<template>
  <el-dialog
    :title="
      dialogConfig.type == '0'
        ? '新增'
        : dialogConfig.type == '1'
        ? '编辑'
        : '详情'
    "
    v-model="visible"
    width="60%"
    style="overflow: hidden"
    :close-on-click-modal="false"
  >
    <!-- <el-dialog v-model="signVisible" title="手写签名">
      <div class="flex-center">
        <vueEsign
          ref="eSign"
          :lineWidth="6"
          lineColor="#000000"
          bgColor="#fff"
        />
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="handleReWrite()">重写</el-button>
          <el-button type="primary" @click="handleGenerate()"> 保存 </el-button>
        </span>
      </template>
    </el-dialog> -->
    <el-collapse
      v-model="activeNames"
      style="overflow-y: auto; height: 55vh"
      v-loading="loading"
    >
      <el-collapse-item title="调拨信息" name="baseMsg">
        <el-form
          :model="formData"
          label-width="100px"
          ref="ruleRef"
          :rules="rules"
          v-if="dialogConfig.type == '0' || dialogConfig.type == '1'"
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <!-- <el-form-item label="调拨单号：" prop="number">
                <el-input
                  v-model="formData.number"
                  placeholder="请输入"
                  :maxlength="40"
                  v-no-space
                />
              </el-form-item> -->
              <el-form-item label="盘点单号： " prop="number">
                <el-input
                  v-model="formData.number"
                  placeholder="系统生成"
                  :maxlength="40"
                  v-no-space
                  :disabled="true"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="出库仓库：" prop="outbound">
                <el-select
                  v-model="formData.outbound"
                  placeholder="请选择"
                  style="width: 100%"
                  @change="outBoundChange"
                >
                  <el-option
                    v-for="item in stashList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="入库仓库：" prop="inbound">
                <el-select
                  v-model="formData.inbound"
                  placeholder="请选择"
                  style="width: 100%"
                  @change="inBoundChange"
                >
                  <el-option
                    v-for="item in stashList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="调拨时间：" prop="allocateTime">
                <el-date-picker
                  type="datetime"
                  v-model="formData.allocateTime"
                  placeholder="请选择"
                  style="width: 100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="调拨人" prop="allocateUser">
                <el-select
                  v-model="formData.allocateUser"
                  placeholder="请选择"
                  style="width: 100%"
                  filterable
                >
                  <el-option
                    v-for="item in userList"
                    :key="item.id"
                    :label="item.nikeName"
                    :value="item.userCode"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col>
              <el-form-item label="备注：" prop="remark">
                <el-input
                  type="textarea"
                  v-model="formData.remark"
                  :rows="3"
                  :maxlength="200"
                  show-word-limit
                  placeholder="请输入"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-descriptions v-else :column="3" border>
          <el-descriptions-item
            v-for="item in descriptionColumns"
            :key="item.value"
            :label="item.label"
            :span="item.span || 1"
            width="16%"
          >
            <span class="my_class">{{ formData[item.value] }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </el-collapse-item>
      <el-collapse-item title="调拨明细" name="allotInfo">
        <div class="flex">
          <el-text type="primary"
            >物料数量：{{ tableData.length }}&nbsp;&nbsp;&nbsp;&nbsp;
            调拨数量：{{
              tableData.reduce((sum, item) => sum + (item.quantity || 0), 0)
            }}</el-text
          >
          <el-button
            type="primary"
            @click="handleMaterielSelect()"
            v-if="dialogConfig.type == '0' || dialogConfig.type == '1'"
            >选择物料</el-button
          >
        </div>
        <el-table
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          class="mt10"
          :data="tableData"
        >
          <el-table-column label="序号" type="index" width="60" fixed />
          <template v-for="item in columns" :key="item.prop">
            <el-table-column
              :label="item.label"
              :prop="item.prop"
              :min-width="120"
              show-overflow-tooltip
            >
              <template #default="{ row }">
                <el-input-number
                  v-model="row[item.prop]"
                  :controls="false"
                  v-if="dialogConfig.type != '2' && item.isInput"
                  :min="0"
                  :max="999999"
                  :precision="4"
                  style="width: 100%"
                />
                <el-input-number
                  v-if="
                    item.prop == 'number' &&
                    (dialogConfig.type == '0' || dialogConfig.type == '1')
                  "
                  v-model="row[item.prop]"
                  :controls="false"
                  style="width: 100%"
                  @change="numberChanged(row)"
                />
                <el-select
                  v-else-if="
                    item.prop == 'inPosition' &&
                    (dialogConfig.type == '0' || dialogConfig.type == '1')
                  "
                  v-model="row[item.prop]"
                >
                  <el-option
                    v-for="location in inPositionList"
                    :key="location.id"
                    :value="location.id"
                    :label="location.name"
                    :disabled="
                      location.id == row.warehousePosition &&
                      formData.outbound == formData.inbound
                    "
                  >
                    <span
                      v-if="
                        location.id == row.warehousePosition &&
                        formData.outbound == formData.inbound
                      "
                    >
                      {{ location.name + "(同一库位)" }}
                    </span>
                    <span v-else>{{ location.name }}</span>
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
          </template>
          <el-table-column
            label="操作"
            fixed="right"
            v-if="dialogConfig.type == '0' || dialogConfig.type == '1'"
          >
            <template #default="{ $index }">
              <el-button type="primary" link @click="handleRemove($index)"
                >移除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-collapse-item>
      <el-collapse-item title="签名信息" name="sign">
        <el-form :model="formData" ref="ruleRef2" :rules="rules">
          <el-row
            :gutter="10"
            v-if="dialogConfig.type == '0' || dialogConfig.type == '1'"
          >
            <el-col :span="12"
              ><el-form-item label="出库人签名：" prop="outboundSign">
                <!-- <el-image
                  v-if="signImg"
                  style="width: 100px; height: 30px"
                  :src="signImg"
                  :preview-src-list="[signImg]"
                />
                <el-button
                  type="primary"
                  link
                  @click="handleSign(1)"
                  v-if="dialogConfig.type == '0' || dialogConfig.type == '1'"
                  >{{ signImg ? "重签" : "签名" }}</el-button
                > -->
                <el-input
                  v-model="formData.outboundSign"
                  placeholder="请输入"
                  :maxlength="40"
                  v-no-space
                />
              </el-form-item>
            </el-col>
            <el-col :span="12"
              ><el-form-item label="入库人签名：" prop="inboundSign">
                <!-- <el-image
                  v-if="putinSignImg"
                  style="width: 100px; height: 30px"
                  :src="putinSignImg"
                  :preview-src-list="[putinSignImg]"
                />
                <el-button
                  type="primary"
                  link
                  @click="handleSign(2)"
                  v-if="dialogConfig.type == '0' || dialogConfig.type == '1'"
                  >{{ putinSignImg ? "重签" : "签名" }}</el-button
                > -->
                <el-input
                  v-model="formData.inboundSign"
                  placeholder="请输入"
                  :maxlength="40"
                  v-no-space
                /> </el-form-item
            ></el-col>
          </el-row>
          <el-row v-else>
            <el-col :span="12">出库人签名：{{ formData.outboundSign }}</el-col>
            <el-col :span="12">入库人签名：{{ formData.inboundSign }}</el-col>
          </el-row>
        </el-form>
      </el-collapse-item>
    </el-collapse>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleCancel()">取消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit()"
          :disabled="buttonLoading"
          v-if="dialogConfig.type == '0' || dialogConfig.type == '1'"
        >
          保存
        </el-button>
      </span>
    </template>

    <!-- 物料选择组件 -->
    <WarehouseManagementcheck
      ref="selectRef"
      type="out"
      @selectDone="materielSelectDone"
    />
  </el-dialog>
</template>

<script setup>
import { ElMessage } from "element-plus";
import { reactive, ref, toRefs } from "vue";
import vueEsign from "vue-esign";
import WarehouseManagementcheck from "@/components/WarehouseManagementcheck.vue";
import useStashList from "../hooks/useStashList";
import { insertAllotNew, updateAllotNew, queryAllotByIdNew } from "@/api/allot";
import { queryStashById } from "@/api/stash";
import { uploadFile } from "@/api/file";
import axios from "axios";
import { base64ToFile } from "@/utils";
import useUserList from "../hooks/useUserList";
// 仓库列表
const { stashList } = useStashList();
const { userList } = useUserList();

const emits = defineEmits(["afterSave"]);

const visible = ref(false);

const signVisible = ref(false);

const eSign = ref(null);

const ruleRef = ref(null);
const ruleRef2 = ref(null);

const selectRef = ref(null);

// 出库人签名
const signImg = ref("");

// 入库人签名
const putinSignImg = ref("");

// 当前选中的签名
const currentSign = ref(1);

// 入库仓库的库位列表
const inPositionList = ref([]);

const activeNames = ref(["baseMsg", "allotInfo", "sign"]);

// 保存按钮loading
const buttonLoading = ref(false);

// 弹窗loading
const loading = ref(false);

// 弹窗参数
const dialogConfig = ref({});

const formData = ref({
  number: null,
  outboundSign: null,
  inboundSign: null,
  allocateTime: null,
  remark: null,
  inbound: null,
  outbound: null,
});

const descriptionColumns = ref([
  {
    label: "调拨单号",
    value: "number",
  },
  {
    label: "出库仓库",
    value: "outBoundWarehouseName",
  },
  {
    label: "入库仓库",
    value: "inBoundWarehouseName",
  },
  {
    label: "调拨时间",
    value: "allocateTime",
  },
  {
    label: "备注",
    value: "remark",
    span: 3,
  },
]);

const rules = reactive({
  // number: [
  //   { required: true, message: "请输入调拨单号", trigger: "blur" },
  //   {
  //     pattern: /^[a-zA-Z0-9]+$/,
  //     message: "只能输入英文和数字",
  //     trigger: "blur",
  //   },
  // ],
  outbound: [{ required: true, message: "请选择出库仓库", trigger: "change" }],
  inbound: [{ required: true, message: "请选择入库仓库", trigger: "change" }],
  outboundSign: [{ required: true, message: "请签名", trigger: "blur" }],
  inboundSign: [{ required: true, message: "请签名", trigger: "blur" }],
  allocateTime: [{ required: true, message: "请选择", trigger: "blur" }],
});

// 物料表格数据
const tableData = ref([]);

// 表格列
const columns = ref([]);

// 弹窗打开
const handleDialogOpen = (config) => {
  dialogConfig.value = { ...config };
  formData.value = {
    number: null,
    outbound: null,
    inbound: null,
    remark: null,
    outboundSign: null,
    inboundSign: null,
    allocateTime: null,
  };
  tableData.value = [];
  ruleRef.value?.resetFields();
  ruleRef2.value?.resetFields();

  signImg.value = "";
  putinSignImg.value = "";
  console.log("config.type", config.type);
  // if (config.type == "0") {
  columns.value = [
    {
      label: "物料名称",
      prop: "materialDTO.name",
    },
    {
      label: "物料编号",
      prop: "materialDTO.number",
    },
    {
      label: "库存数量",
      prop: "inventoryQuantity",
    },
    {
      label: "单位",
      prop: "materialDTO.unit",
    },
    {
      label: "调拨数量",
      prop: "quantity",
      isInput: true,
    },
  ];
  // }
  //  else if (config.type == "2") {
  //   columns.value = [
  //     {
  //       label: "物料名称",
  //       prop: "materialDTO.name",
  //     },
  //     {
  //       label: "物料编号",
  //       prop: "materialDTO.number",
  //     },
  //     {
  //       label: "库存数量",
  //       prop: "inventoryQuantity",
  //     },
  //     {
  //       label: "单位",
  //       prop: "materialDTO.unit",
  //     },
  //     {
  //       label: "调拨数量",
  //       prop: "quantity",
  //       isInput: false,
  //     },
  //   ];
  // }

  if (config.type != "0") {
    getDetail(config.row.id);
  }

  visible.value = true;
};

// 根据id获取详情
const getDetail = (id) => {
  loading.value = true;
  queryAllotByIdNew(id)
    .then((res) => {
      formData.value["number"] = res.data.number;
      formData.value["allocateTime"] = res.data.allocateTime;
      formData.value["remark"] = res.data.remark;
      formData.value["outboundSign"] = res.data.outboundSign;
      formData.value["inboundSign"] = res.data.inboundSign;
      formData.value["inbound"] = res.data.inbound;
      formData.value["outbound"] = res.data.outbound;
      formData.value["allocateUser"] = res.data.allocateUser;
      formData.value["id"] = res.data.id;
      formData.value["outBoundWarehouseName"] = res.data.outBoundWarehouse.name;
      formData.value["inBoundWarehouseName"] = res.data.inBoundWarehouse.name;

      tableData.value = res.data.aiDTOList;
      tableData.value.forEach((item) => {
        console.log("======>", item);
        item.outboundName = item.outBoundWarehouse.name;
        item.inboundName = item.inBoundWarehouse.name;
      });
    })
    .finally(() => {
      // previewImg(formData.value.outboundSign, signImg);
      // previewImg(formData.value.inboundSign, putinSignImg);
      loading.value = false;
    });
};

// 点击签名
const handleSign = (type) => {
  currentSign.value = type;
  signVisible.value = true;
};

// 签名重写
const handleReWrite = () => {
  eSign.value?.reset();
};

// 生成签名
// const handleGenerate = () => {
//   eSign.value
//     // ?.generate({ format: "image/jpeg", quality: 0.5 })
//     ?.generate() // base64默认
//     .then((res) => {
//       if (currentSign.value == 1) {
//         signImg.value = res;
//         uploadSign(res, "出库人.jpg", "outboundSign");
//       } else {
//         putinSignImg.value = res;
//         uploadSign(res, "入库人.jpg", "inboundSign");
//       }
//       handleReWrite();
//       signVisible.value = false;
//     })
//     .catch((e) => {
//       ElMessage.error("未识别到签名");
//     });
// };

// // 上传签名
// const uploadSign = (dataUrl, name, type, isFile) => {
//   if (!dataUrl) return;
//   let result;
//   let file;
//   let reqBody = new FormData();
//   file = isFile ? dataUrl : base64ToFile(dataUrl, name);

//   reqBody.append("file", file);
//   uploadFile(reqBody).then((res) => {
//     result = res.data.reduceUrl;
//     formData.value[type] = result;
//   });
// };

// 表格移除
const handleRemove = (index) => {
  tableData.value.splice(index, 1);
};

// 选择物料
const handleMaterielSelect = () => {
  if (!formData.value.outbound || !formData.value.inbound)
    return ElMessage.warning("请先选择【出库、入库】仓库");
  let ids = [];
  tableData.value.forEach((item) => {
    ids.push(item.id);
  });
  // 传入出库仓库的id  因为调拨是从一个仓库出库  然后另一个仓库入库
  selectRef.value?.handleDialogOpen(ids, formData.value.outbound);
};

// 物料选择结束回调
const materielSelectDone = (val) => {
  // tableData.value = [...val];
  // tableData.value.map((i) => {
  //   var obj = JSON.parse(JSON.stringify(i));
  //   i.inventoryQuantity = obj.quantity;
  //   i.quantity = 0;
  //   i.inventoryId = i.inventoryId;
  //   i.materialName = i.name;
  //   i.materialNumber = i.number;
  //   i.number = null;
  //   i.outboundName = i.warehousePositionName;
  //   i.outPosition = i.warehousePosition;
  // });
  val.map((i) => {
    var obj = JSON.parse(JSON.stringify(i));
    i.inventoryQuantity = obj.quantity;
    i.quantity = 0;
    i.inventoryId = i.inventoryId;
    i.materialName = i.name;
    i.materialNumber = i.number;
    i.number = null;
    i.outboundName = i.warehousePositionName;
    i.outPosition = i.warehousePosition;
  });
  // 创建一个Set用来存储val数组中的number
  let numbersInTable = new Set(tableData.value.map((item) => item.id));

  // 遍历val数组，将不在table数组中的对象加入table数组
  val.forEach((item) => {
    if (!numbersInTable.has(item.id)) {
      tableData.value.push(item);
      numbersInTable.add(item.id);
    }
  });
};

// 点击保存
const handleSubmit = () => {
  if (dialogConfig.value.type == 0) {
    buttonLoading.value = true;
    ruleRef.value?.validate((valid) => {
      ruleRef2.value?.validate((valid2) => {
        if (valid && valid2) {
          let validateRes = formValidate();
          if (!validateRes) return (buttonLoading.value = false);
          let arr = [...tableData.value];
          arr.map((i) => {
            if (i.id) {
              i.id = null;
            }
          });
          let reqBody = {
            ...formData.value,
            aiReqList: arr,
          };
          addAllot(reqBody);
        } else {
          buttonLoading.value = false;
        }
      });
    });
  } else if (dialogConfig.value.type == 1) {
    buttonLoading.value = true;
    ruleRef.value?.validate((valid) => {
      ruleRef2.value?.validate((valid2) => {
        if (valid && valid2) {
          let validateRes = formValidate();
          if (!validateRes) return (buttonLoading.value = false);
          let arr = [...tableData.value];
          // arr.map((i) => {
          //   if (i.id) {
          //     i.id = null;
          //   }
          // });
          let reqBody = {
            ...formData.value,
            aiReqList: arr,
          };
          updateAllotNew(reqBody).then((res) => {
            if (res.code == "2000") {
              ElMessage.success("操作成功");
              emits("afterSave");
              visible.value = false;
            }
          });
          setTimeout(() => {
            buttonLoading.value = false;
          }, 300);
        } else {
          buttonLoading.value = false;
        }
      });
    });
  }
};

// 表单提交前校验
const formValidate = () => {
  // 判断是否有选择物料
  if (tableData.value.length == 0) {
    ElMessage.error("未选择任何物料");
    return false;
  }

  // // 判断物料列表中的库位和数量是否填充完毕
  // const arr = tableData.value.filter((item) => {
  //   return item.inPosition && item.number;
  // });

  // if (arr.length == 0) {
  //   ElMessage.error("物料库位和数量是必填项");
  //   return false;
  // }

  // 判断是否签名
  // if (!formData.value.outboundSign || !formData.value.inboundSign) {
  //   ElMessage.error("请先签名");
  //   return false;
  // }
  return true;
};

// 点击取消
const handleCancel = () => {
  ruleRef.value?.resetFields();
  visible.value = false;
};

// 新增
const addAllot = (req) => {
  insertAllotNew(req).then((res) => {
    if (res.code == "2000") {
      ElMessage.success("操作成功");
      emits("afterSave");
      visible.value = false;
    }
  });
  setTimeout(() => {
    buttonLoading.value = false;
  }, 300);
};

// 获取库位列表
const getPositionList = (id) => {
  queryStashById(id).then((res) => {
    inPositionList.value = res.data.warehousePositionList || [];
  });
};

// 仓库变化--入库
const inBoundChange = (val) => {
  console.log(formData.value.inbound, formData.value.outbound);
  if (formData.value.inbound == formData.value.outbound) {
    ElMessage.error("出库仓库与入库仓库不能相同");
    formData.value.inbound = null;
  } else {
    tableData.value.map((i) => {
      i.inPosition = null;
    });
    getPositionList(val);
  }
};

// 仓库变化--出库
const outBoundChange = (val) => {
  if (formData.value.inbound == formData.value.outbound) {
    ElMessage.error("出库仓库与入库仓库不能相同");
    formData.value.outbound = null;
  } else {
    tableData.value = [];
  }
};

//  文件预览
const previewImg = (fields, target) => {
  let result;
  axios
    .post(
      "/api/storeroom/file/preview",
      {
        reduceUrl: fields,
      },
      { responseType: "arraybuffer" }
    )
    .then((res) => {
      let url = "";
      const bytes = new Uint8Array(res.data);
      let len = bytes.length;
      for (let i = 0; i < len; i++) {
        url += String.fromCharCode(bytes[i]);
      }
      result = "data:image/jpg;base64," + window.btoa(url);
    })
    .finally(() => {
      target.value = result;
    });
};

// 调拨数量发生变化
const numberChanged = (row) => {
  if (row.number > row.inventoryNumber) {
    ElMessage.warning("调拨数量不可大于库存数量");
    row.number = row.inventoryNumber;
  }
};

defineExpose({
  handleDialogOpen,
});
</script>

<style scoped>
.flex {
  display: flex;
  justify-content: space-between;
}

.mt10 {
  margin-top: 5px;
}
.flex-center {
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  border: 1px solid #ccc;
}
.my_class {
  max-width: 100%;
  word-break: break-all;
  word-wrap: break-word;
}
</style>
